import { SemVer } from "semver";

export class LibrariesOutdated extends Error {

}
export default class LibraryManager {
    initializeLibrary() {
        fetch('/libconfig.json')
            .then((response) => response.json())
            .then((json) => this.libconfig = json);
    }
    async checkForLibaries(codeUploader){
        if(await codeUploader.getFileContent(this.libconfig.versionFile) !== this.libconfig.version){
            console.log("Libraries need to be updated!")
            await this.uploadLibraries(codeUploader)
            await codeUploader.upload(this.libconfig.version, this.libconfig.versionFile)
        }
        console.log("Libraries up to date!")
    }

    async checkForBaseLibraries(codeUploader) {
        let currentVersions = await codeUploader.getFirmwareVersion()
        console.log(currentVersions)
        if(!currentVersions.firmwareVersion || !currentVersions.libVersion){
            throw Error()
        }
        let firmwareVersion = new SemVer(currentVersions.firmwareVersion)
        let libVersion = new SemVer(currentVersions.libVersion)
        if(firmwareVersion.compare(this.libconfig.fwVersion) === -1 || libVersion.compare(this.libconfig.libVersion) === -1){
            throw LibrariesOutdated()
        }
    }

    async uploadLibraries(codeUploader){
        console.log(this.libconfig)
        for (let i = 0; i < this.libconfig.dirs.length; i++) {
            const dirPath = this.libconfig.dirs[i];
            await codeUploader.createDirectory(dirPath)
        }
        for (let i = 0; i < this.libconfig.files.length; i++) {
            const filePath = this.libconfig.files[i];
            var fileContent = await this.fetchLibrary(filePath)
            await codeUploader.upload(fileContent, filePath)
        }
    }

    async fetchLibrary(path){
        return await fetch(path).then(content => content.text())
    }
}